import React, { useState, useContext, useEffect } from "react";
import api from '../../../services/api';
import Swal from "sweetalert2";
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { MobileContext } from "../../../contexts/MobileContext";
import { StyledCalendarioPage } from "../../../styled-components/StyledCalendarioPage.style";
import { ModalCalendarioFeriadosEventosAdicionar } from "../../../components/ModalCalendarioFeriadosEventosAdicionar";
import { ModalCalendarioFeriadosEventosAdicionarAno } from "../../../components/ModalCalendarioFeriadosEventosAdicionarAno";

export const CalendarioFeriadosEventos = () => {
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;

    const [modalAdicionar, setModalAdicionar] = useState(false);
    const [modalAdicionarAno, setModalAdicionarAno] = useState(false);
    const [anoSelecionado, setAnoSelecionado] = useState(null);
    const [idRecessoSelecionado, setIdRecessoSelecionado] = useState(null);
    
    const [listaAnos, setListaAnos] = useState([]);
    const [isLoadingList, setIsLoadingList] = useState(false);

    const carregarAnos = async () => {
        setIsLoadingList(true);
        try {
            const response = await api.get('WipRecesso/list');
            const dados = response.data.data || [];
            setListaAnos(dados);
        } catch (error) {
            console.error("Erro ao buscar a lista de anos:", error);
            Swal.fire('Erro', 'Não foi possível carregar os anos cadastrados.', 'error');
        } finally {
            setIsLoadingList(false);
        }
    };

    useEffect(() => {
        carregarAnos();
    }, []);

    const openModalAdicionar = (ano, idRecesso) => {
        setAnoSelecionado(ano);
        setIdRecessoSelecionado(idRecesso);
        setModalAdicionar(true);
    }

    const closeModalAdicionar = (currentValue, value) => {
        setModalAdicionar(false);
        carregarAnos(); 
    }

    const openModalAdicionarAno = () => {
        setModalAdicionarAno(true);
    }
    const closeModalAdicionarAno = (currentValue, value) => {
        setModalAdicionarAno(false);
        carregarAnos();
    }

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledCalendarioPage style={{ overflowX: 'hidden', width: '100%' }}>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header m-0">Calendário de Feriados e Eventos</h5>
                        </div>
                    </div>
                    <div className="card py-1 px-2 mt-2">
                        <div className="row justify-content-between mb-3">
                            <div className="col-sm-12 col-md-2 col-lg-2  pt-2">
                                <input type="button" className='default-button-red-block btn-block' value='Adicionar' onClick={() => openModalAdicionarAno()} />
                            </div>
                        </div>
                        <p>Esta página exibe o calendário de feriados e eventos importantes para a empresa.</p>

                        <div className="table-scroll font-0-9x table-bordered table-container">
                            <table className="table table-width">
                                <thead>
                                    <tr className="table-legend-info">
                                        <th style={{width: '10%'}} key="ac">Ações</th>
                                        <th style={{width: '90%'}} key="nomePrograma">Ano</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoadingList ? (
                                        <tr>
                                            <td colSpan="2" className="text-center py-3">Carregando...</td>
                                        </tr>
                                    ) : listaAnos.length === 0 ? (
                                        <tr>
                                            <td colSpan="2" className="text-center py-3">Nenhum ano cadastrado no sistema.</td>
                                        </tr>
                                    ) : (
                                        listaAnos.map((item) => (
                                            <tr key={item.idRecessoCompetencia}>
                                                <td>
                                                    <span className="cursor-pointer color-icon-default m-1" onClick={() => openModalAdicionar(item.anoCompetencia, item.idRecessoCompetencia)} title="Editar Feriados">
                                                        <i className="fa fa-edit" aria-hidden="true"></i>
                                                    </span>
                                                    {/* <span className="cursor-pointer color-icon-default m-1" onClick={() => console.log('Excluir', item.idRecessoCompetencia)} title="Excluir Ano">
                                                        <i className="fa fa-ban"></i>
                                                    </span> */}
                                                </td>
                                                <td>
                                                    {item.anoCompetencia}
                                                    
                                                    {item.isConfigurado === false && (
                                                        <span 
                                                            className="ms-3" 
                                                            style={{
                                                                backgroundColor: '#ffc107',
                                                                color: '#856404', 
                                                                padding: '4px 8px', 
                                                                borderRadius: '4px', 
                                                                fontSize: '11px', 
                                                                fontWeight: 'bold',
                                                                verticalAlign: 'middle',
                                                                border: '1px solid #ffeeba'
                                                            }}
                                                            title="Este ano foi criado, mas os feriados ainda não foram salvos no banco."
                                                        >
                                                            <i className="fa fa-exclamation-triangle pe-1"></i>
                                                            Pendente de Configuração
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <ModalCalendarioFeriadosEventosAdicionar
                        key={"ModalCalendarioFeriadosEventosAdicionar"}
                        isOpen={modalAdicionar}
                        setIsOpen={() => setModalAdicionar(false)}
                        onRequestClose={closeModalAdicionar}
                        ano={anoSelecionado}
                        idRecessoCompetencia={idRecessoSelecionado}
                    >
                    </ModalCalendarioFeriadosEventosAdicionar>

                    <ModalCalendarioFeriadosEventosAdicionarAno
                        key={"ModalCalendarioFeriadosEventosAdicionarAno"}
                        isOpen={modalAdicionarAno}
                        setIsOpen={() => setModalAdicionarAno(false)}
                        onRequestClose={closeModalAdicionarAno}
                    >
                    </ModalCalendarioFeriadosEventosAdicionarAno>

                </StyledCalendarioPage>
            </main>
        </section>
    );
}

export const CalendarioFeriadosEventosPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <CalendarioFeriadosEventos />
                </>
            )}
        </>
    );
}